const locales = {
}

export default locales